import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Check, X } from '../../bravosIcons';
import './ExerciseEditSavedToast.css';

export interface ExerciseEditSavedToastProps {
  exerciseName: string;
  onDismiss: () => void;
  /** @default 'edit' */
  variant?: 'edit' | 'create' | 'assign-plan' | 'assign-workout' | 'workout' | 'workout-created' | 'plan-created' | 'plan-saved' | 'duplicate' | 'plan-duplicate';
  planName?: string;
  workoutName?: string;
  memberDisplayName?: string;
}

export function ExerciseEditSavedToast({
  exerciseName,
  onDismiss,
  variant = 'edit',
  planName,
  workoutName,
  memberDisplayName,
}: ExerciseEditSavedToastProps) {
  useEffect(() => {
    const t = window.setTimeout(onDismiss, 5000);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- single 5s dismiss timer per toast mount
  }, []);

  const node = (
    <div className="eed-save-toast" role="status" aria-live="polite">
      <div className="eed-save-toast-inner">
        <span className="eed-save-toast-icon" aria-hidden="true">
          <Check width={16} height={16} strokeWidth={2.5} color="currentColor" />
        </span>
        <div className="eed-save-toast-text">
          <strong>
            {variant === 'assign-plan'
              ? `${planName ?? 'Plan'} assigned`
              : variant === 'assign-workout'
                ? `${workoutName ?? 'Workout'} assigned`
              : variant === 'create'
                ? `${exerciseName} created`
                : variant === 'workout'
                ? 'Workout saved'
              : variant === 'workout-created'
                ? 'Workout created'
                : variant === 'plan-created'
                  ? 'Plan created'
                : variant === 'plan-saved'
                  ? 'Plan saved'
                : variant === 'plan-duplicate'
                  ? 'Plan duplicated'
                : variant === 'duplicate'
                  ? 'Workout duplicated'
                  : 'Changes saved'}
          </strong>
          <span className="eed-save-toast-sub">
            {variant === 'assign-plan' || variant === 'assign-workout'
              ? `Added to ${memberDisplayName ?? 'member'}'s schedule`
              : variant === 'create'
                ? 'Exercise added to your library'
                : variant === 'workout'
                  ? `${exerciseName} updated in your library`
                : variant === 'workout-created'
                  ? `${exerciseName} added to your library`
                : variant === 'plan-created'
                  ? `${planName ?? exerciseName} added to your library`
                : variant === 'plan-saved'
                  ? `${planName ?? exerciseName} updated in your library`
                : variant === 'plan-duplicate'
                  ? 'Opening your new plan…'
                : variant === 'duplicate'
                  ? 'Opening your new workout…'
                  : `${exerciseName} updated in your library`}
          </span>
        </div>
        <button type="button" className="eed-save-toast-dismiss" aria-label="Dismiss" onClick={onDismiss}>
          <X width={16} height={16} strokeWidth={2} />
        </button>
      </div>
      <div className="eed-save-toast-progress-track" aria-hidden="true">
        <div className="eed-save-toast-progress-bar" />
      </div>
    </div>
  );

  return createPortal(node, document.body);
}
